import React from 'react';

import { Typography } from '@material-ui/core';
import cx from 'classnames';

import useStyles from './styles';

interface CardHeaderProps {
  text: string;
  className?: string;
}

const CardHeader: React.FC<CardHeaderProps> = ({ text, className }) => {
  const classes = useStyles();

  return (
    <Typography variant="h3" className={cx(classes.header, className)}>
      {text}
    </Typography>
  );
};

export default CardHeader;
